import { render, staticRenderFns } from "./LoginEmail.vue?vue&type=template&id=5b0c9a4e&scoped=true&"
import script from "./LoginEmail.vue?vue&type=script&lang=js&"
export * from "./LoginEmail.vue?vue&type=script&lang=js&"
import style0 from "./LoginEmail.vue?vue&type=style&index=0&id=5b0c9a4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0c9a4e",
  null
  
)

export default component.exports